import styled from 'styled-components';
import PrimaryButton from '@carvana/showroom-forms/Button/Primary';

const CalendarModalContent = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  background: ${(props) => props.theme.color.neutral.v100};
  box-sizing: content-box;

  @media (min-width: ${(props) => props.theme.breakpoint.xs}px) {
    padding: 40px 25px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    padding: 40px 80px 60px;
    height: 585px;
  }
`;

const CalendarTitle = styled.h3`
  ${(props) => props.theme.font.heading.v100};
  font-weight: ${(props) => props.theme.font.weight.v300};
  text-transform: uppercase;
  margin: 10px 0;
  text-align: center;
`;

const HR = styled.hr`
  border: 1px solid ${(props) => props.theme.color.neutral.v300};
  width: 100%;
  border-bottom-color: transparent;
`;

const ConfirmButton = styled(PrimaryButton)`
  width: 250px;
  height: 55px;
  background: #00aed9;
  color: #ffffff;
  text-align: center;
`;

export { CalendarModalContent, CalendarTitle, HR, ConfirmButton };
